export default [{
    path: 'equipment-type-tree',
    component: () => import('@/views/dcim/equipment/equipment-type-tree-index'),
}]
